import axios, { AxiosRequestConfig, AxiosResponse } from 'axios';

import { GameActionCreators } from '../store/reducers/game/action-creators';
import {store} from "../store";

export default class RequestHelper {
    static async postWithDelayedLoading(
        url: string,
        data: any,
        config?: AxiosRequestConfig,
        delay = 2000
    ): Promise<AxiosResponse<any>> {
        let loadingShown = false;

        const timer = setTimeout(() => {
            loadingShown = true;

            store.dispatch(GameActionCreators.setIsBattleLoading(true));
        }, delay);

        try {
            const response = await axios.post(url, data, config);

            return response;
        } finally {
            clearTimeout(timer);

            if (loadingShown) {
                store.dispatch(GameActionCreators.setIsBattleLoading(false));
            }
        }
    }
}